import React, { useState } from 'react';
import LastPicture from './LastPicture';
import InfoBox from './InfoBox';
import AIPriorityScore from './AIPriorityScore';
import { useSelector } from 'react-redux';
import ImageModal from './ImageModal';

function ImageBox({ device }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loadedSrc, setLoadedSrc] = useState(null);
  const selectedMeasurementIndex = useSelector((state) => state.mapState.selectedMeasurementIndex);

  if (!device?.measures?.length) {
    return null;
  }
  
  const measurement = selectedMeasurementIndex !== null 
    ? device.measures[selectedMeasurementIndex]
    : device.measures[device.measures.length - 1];

  const readings = {};
  measurement.readings.forEach(reading => {
    const key = reading.key.toLowerCase().replace(' ', '_');
    readings[key] = reading.value;
    readings[`${key}_status`] = reading.status;
  });

  return (
    <>
      <main 
        className="h-full cursor-pointer"
        onClick={() => setIsModalOpen(true)}
      >
        <section className="h-full w-full flex items-center justify-center">
          <div className="relative h-full w-full">
            <div className="relative h-full w-full flex items-center justify-center">
              {loadedSrc !== `/images/sensor/${measurement.image}` && (
                <div className="absolute inset-0 flex items-center justify-center bg-gray-100 animate-pulse rounded">
                  <svg className="w-12 h-12 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </div>
              )}
              <img
                src={`/images/sensor/${measurement.image}`}
                alt="Main image"
                className={`max-h-full max-w-full object-contain transition-opacity duration-200 ${loadedSrc === `/images/sensor/${measurement.image}` ? 'opacity-100' : 'opacity-0'}`}
                onLoad={(e) => setLoadedSrc(e.target.src.replace(window.location.origin, ''))}
              />
              <LastPicture 
                date={measurement.date} 
                time="10:34AM" 
                className="absolute top-0 left-0 text-sm" 
              />
              <div className="absolute bottom-4 left-4 right-4 flex gap-2">
                <InfoBox
                  type={device.type}
                  readings={measurement.readings}
                />
                <AIPriorityScore score={parseInt(measurement.ai_score)} />
              </div>
            </div>
          </div>
        </section>
      </main>

      {isModalOpen && (
        <ImageModal 
          device={device} 
          onClose={() => setIsModalOpen(false)} 
        />
      )}
    </>
  );
}

export default ImageBox;